export const PROCESSOS_BASE_URL = '/wsprocesso/api'
export const ESTRUTURA_BASE_URL = `${PROCESSOS_BASE_URL}/estrutura`